












































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { ILoginRequest } from "@/types/login";

@Component({
  components: {}
})
export default class extends Vue {
  @Action("auth/setRedirectUrl")
  public setRedirectUrl!: (url: string) => boolean;
  @Action("login/login")
  public login!: (request: ILoginRequest) => boolean;
  @Action("auth/deauthorize")
  public deauthorize!: () => void;
  @Getter("login/redirectUrl")
  public redirectUrl!: string;
  @Getter("auth/isCustomer")
  public isCustomer!: boolean;
  @Getter("error/error")
  public getError!: (key: string) => string[];
  @Mutation("login/clearRedirectUrl")
  public clearRedirectUrl!: () => void;

  public form: ILoginRequest = {
    login_id: "",
    password: ""
  };

  private loading = false;

  public async created() {
    this.deauthorize();
    this.clearRedirectUrl();
  }

  //--------
  // ログインボタン押下時
  public async loginClicked() {
    if (!(await this.login(this.form))) {
      return;
    }

    const route_name = this.isCustomer ? "CustomerHome" : "Login";
    const route: { name?: string; path?: string; query?: {} } = {
      name: route_name
    };

    return this.$router.push(route);
  }
}
